export default __webpack_public_path__ + "static/media/lock.f504a074.svg";